import { EMManagement } from 'components/EMManagement';
import { Page } from 'layouts/Page';

export const EMManagementPage = () => {
	return (
		<Page title="EM Management – EAS Control Center">
			<EMManagement />
		</Page>
	);
};
